import { createStore, applyMiddleware, combineReducers } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import UserSaga from '@services/user/saga'
import UserReducer from '@services/user/reducer';
import FunderApplicantSaga from '@services/funder-applicant/saga';
import FunderApplicantReducer from '@services/funder-applicant/reducer';
import MarketplaceSaga from '@services/marketplace/saga';
import MarketplaceReducer from '@services/marketplace/reducer';
import FunderSaga from '@services/funder/saga';
import FunderReducer from '@services/funder/reducer';
import BalanceAssetSaga from '@services/balance-asset/saga';
import BalanceAssetReducer from '@services/balance-asset/reducer';
import MigrationReducer from '@services/migration/action_reducer';
import MigrationSaga from '@services/migration/saga';
import ReportSaga from '@services/report/saga';
import ReportReducer from '@services/report/reducer';

//Redux Saga Listener
function* rootSaga() {
    yield all([
        fork(UserSaga),
        fork(FunderApplicantSaga),
        fork(FunderSaga),
        fork(MarketplaceSaga),
        fork(BalanceAssetSaga),
        fork(MigrationSaga),
        fork(ReportSaga)
    ]);
}

//Reference: https://medium.com/@victor36max/using-redux-saga-with-next-js-2b5d5add1ec6
function configStore(initialState, { isServer, req = null }) {

    const sagaMiddleware = createSagaMiddleware();
    const store = createStore(
        combineReducers({
            UserReducer,
            FunderApplicantReducer,
            MarketplaceReducer,
            FunderReducer,
            BalanceAssetReducer,
            MigrationReducer,
            ReportReducer
        }),
        initialState,
        applyMiddleware(sagaMiddleware)
    );

    if (!store.sagaTask && (req || !isServer)) {
        store.sagaTask = sagaMiddleware.run(rootSaga);
    }

    return store;
}

export { configStore };